// The objects in this file map each space token prop value (e.g. `space` = `none`) to the correct theme token name (e.g. `HDS_TEXT_MARGIN_ZERO`).
export const spacingMap = {
  none: 'HDS_SPACE_NONE',
  '50': 'HDS_SPACE_50',
  '100': 'HDS_SPACE_100',
  '150': 'HDS_SPACE_150',
  '200': 'HDS_SPACE_200',
  '250': 'HDS_SPACE_250',
  '300': 'HDS_SPACE_300',
  '350': 'HDS_SPACE_350',
  '400': 'HDS_SPACE_400',
  '450': 'HDS_SPACE_450',
  '500': 'HDS_SPACE_500',
  '600': 'HDS_SPACE_600',
  '700': 'HDS_SPACE_700',
  '800': 'HDS_SPACE_800',
  '900': 'HDS_SPACE_900',
  '1000': 'HDS_SPACE_1000',
  '1100': 'HDS_SPACE_1100',
  '1200': 'HDS_SPACE_1200',
  '1300': 'HDS_SPACE_1300',
  '1400': 'HDS_SPACE_1400',
  '1500': 'HDS_SPACE_1500'
};